export default __webpack_public_path__ + "static/media/trash.f61e3539.svg";